import App from '@layouts/app.vue'
import { useGlobalStore } from '@stores/global'
import { useStoreStore } from '@stores/store'
import { useNewsStore } from '@stores/news'
import { useProductStore } from '@stores/product'
import { createPinia } from 'pinia'
import 'swiper/css'
import 'swiper/css/navigation'
import { createApp } from 'vue/dist/vue.esm-bundler'

import '../css/app.css'
import './bootstrap'
import router from './router'

const pinia = createPinia()
const app = createApp(App).use(router).use(pinia)
const global = useGlobalStore()
const store = useStoreStore()
const news = useNewsStore()
const product = useProductStore()

global.setup()
store.setup()
news.setup()
product.setup()
app.mount('#hennep')
